import { useState } from 'react'

function useOnValueChange<T>(value: T, callback: () => void): void {
  const [previous, setPrevious] = useState(value)

  if (previous !== value) {
    setPrevious(value)
    callback()
  }
}

export default useOnValueChange
